export default {
  SET_CATEGORIES(state, categories) {
    state.categories = categories;
  },
  SET_MY_CATEGORIES(state, categories) {
    state.myCategories = categories;
  },
  SET_MY_CATEGORIES_COUNT(state, data) {
    state.myCategoriesCount = data;
  },
  SET_MY_DISCIPLINES_COUNT(state, data) {
    state.myDisciplinesCount = data;
  }
};
